import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
    FormInputComponent,
    InputComponentConfig,
    DataService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
    AmountPayload,
    Variant,
    VariantWithOrderAmountsArgPayload,
} from './helpers/types';

@Component({
    standalone: true,
    selector: 'variants-order-amount-form-input',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    template: `
        <div class="container">
            <span
                >Mínimo valor permitido dos produtos selecionados: R$
                {{ amounts.minAmount }}</span
            >

            <div *ngIf="amounts.maxAmount">
                <span
                    >Valor máximo permitidos dos produtos comprados: R$
                    {{ amounts.maxAmount }}</span
                >
            </div>

            <div class="container" *ngFor="let variant of variants">
                <div>
                    <div *ngIf="variant.featuredAsset">
                        <img
                            [src]="variant.featuredAsset.source"
                            alt="Product Variant"
                            width="20"
                        />
                    </div>
                    <div class="informations">
                        <span>ID: {{ variant.id }}</span>
                        <span>SKU: {{ variant.sku }}</span>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            img {
                width: 20%;
            }

            .informations {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .container {
                margin-bottom: 30px;
            }
        `,
    ],
})
export class VariantsOrderAmountFormInput
    implements FormInputComponent<InputComponentConfig>, OnInit
{
    @Input() readonly: boolean = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;

    variants: Variant[] = [];
    amounts: AmountPayload = {
        minAmount: 0,
    };

    constructor(
        private dataService: DataService,
        private notificationService: NotificationService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.searchVariantByIds();
    }

    searchVariantByIds(): void {
        const {
            variantIds,
            minAmount,
            maxAmount,
        }: VariantWithOrderAmountsArgPayload = JSON.parse(
            this.formControl.value
        );

        const variantIdsFormatted = variantIds.map((item) => item.toString());
        this.dataService.product
            .getProductVariants({
                filter: { id: { in: variantIdsFormatted } },
            })
            .mapStream((response) => response.productVariants.items)
            .subscribe({
                next: (variants) => {
                    this.variants = variants;
                    this.amounts = { minAmount, maxAmount };
                    this.cd.detectChanges();
                },
                error: (err) => {
                    this.notificationService.error(
                        'Erro ao buscar variantes: ',
                        err
                    );
                },
            });
    }
}
